import { FC, Fragment } from "react";
import { Link } from "@mui/material";
import { AutomationEnvironmentContent } from "../../../../common/components/form/environment-content/AutomationEnvironmentContent";
import { useAppSelector } from "../../../../../../../store/hooks";
import { workflowActionSelector } from "../../../../../../../store/automations/selectros/workflow/workflowActionSelector";
import { c8rTermsAndConditionsLink } from "../../../../../../utils/constants/c8rTermsAndConditionsLink";

export const WorkflowEnvironmentContent: FC = () => {
  const currentAction = useAppSelector(workflowActionSelector);

  return (
    <AutomationEnvironmentContent
      alertMessage={
        currentAction === "clean_and_notify" ? alertMessage : undefined
      }
    />
  );
};

const linkStyles = { color: "inherit", textDecorationColor: "#663C00" };

const alertMessage = (
  <Fragment>
    Executing automation actions on production accounts is not recommended, as
    it may impact critical resources. Check our {""}
    <Link href={c8rTermsAndConditionsLink} sx={linkStyles} target="_blank">
      Terms and Conditions.
    </Link>
  </Fragment>
);
